module.exports = __webpack_public_path__ + "img/img-default-actividades.353d1a03.png";